import React from 'react';
import { Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Footer } from '../../Components/Footer';
import {
  DepositClass,
  FolioType,
  PaymentType,
  useBillSummaryDetailsQuery,
  useGuestAppFeatureQuery,
  useIsXenditQuery,
  useOnlinePaymentMutation,
  usePreRegBookingInfoQuery,
  usePreRegPaymentInsertMutation,
} from '../../generated/graphql';
import SnackBarMsg from '../../Components/SnackBar/SnackBarMsg';
import { useSnackBar } from '../../Components/Hooks/useSnackBar';
import Loading from '../../Components/Loading/Loading';
import { differenceInDays } from 'date-fns';
import { amtStr } from '../../Components/helper/numFormatter';
import dateFormat from 'dateformat';

export let PaymentUrl = '';
switch (process.env.REACT_APP_API_URL) {
  case 'dev-build':
    PaymentUrl = 'https://hotelx-dev.ifca.io';
    break;
  case 'prod-build':
  case 'hms1-prod-build':
  case 'hms2-prod-build':
  case 'hms3-prod-build':
    PaymentUrl = 'https://pre-reg-checkin.hotelx.asia';
    break;
  case 'promenade-build':
    PaymentUrl = 'https://pre-reg-checkin-promenade.hotelx.asia';
    break;
  case 'promenade-uat-build':
    PaymentUrl = 'https://pre-reg-checkin-promenade-uat.hotelx.asia';
    break;
  case 'uat-build':
    PaymentUrl = 'https://pre-reg-checkin-uat.hotelx.asia';
    break;
  case 'hms5-build':
    PaymentUrl = 'https://pre-reg-checkin5.hotelx.asia';
  break;
  case 'noble-melaka-build':
    PaymentUrl = 'https://hotelx-pre-reg-checkin.hotelxnobleresorthotelmelaka.com';
  break;
  default:
    PaymentUrl = 'http://localhost:3302';
    break;
}

export const Payment = ({
  activeStep,
  setActiveStep,
  RegistrationDetails,
}) => {
  const selectedRoomID = JSON.parse(localStorage.getItem('SelectedRoom') as any)?.ID;
  const { snackFunc, snackBarMessage, openSnackBar } = useSnackBar();

  const {
    loading: BillSummaryDetailsLoadings,
    data: { BillSummaryDetails } = { BillSummaryDetails: null },
  } = useBillSummaryDetailsQuery({
    variables: {
      BillSummaryInput: {
        HotelID: RegistrationDetails?.Booking?.HotelID,
        RegistrationID: RegistrationDetails?.ID,
        ArrivalDate: RegistrationDetails?.ArrivalDate,
        DepartureDate: RegistrationDetails?.DepartureDate,
        IsChooseRoom: selectedRoomID ? true : false,
        RoomID: selectedRoomID ? JSON.parse(localStorage.getItem('SelectedRoom') as any)?.ID : undefined,
      },
    },
    fetchPolicy: 'no-cache',
  });

  const {
    data: { IsXendit } = { IsXendit: null },
  } = useIsXenditQuery({
    fetchPolicy: 'no-cache',
    variables: {
      HotelID: RegistrationDetails?.Booking?.HotelID,
    },
  })

  const {
    loading: loadingInfo,
    data: { PreRegBookingInfo } = { PreRegBookingInfo: [] },
  } = usePreRegBookingInfoQuery({
    variables: {
      HotelID: RegistrationDetails?.Booking?.HotelID,
      BookingID: RegistrationDetails?.Booking?.ID,
      RegistrationID: RegistrationDetails?.ID,
      QR: 'true',
    },
    fetchPolicy: 'no-cache',
  });

  const {
    loading: GuestAppFeatureLoadings,
    data: { GuestAppFeature } = { GuestAppFeature: null },
  } = useGuestAppFeatureQuery({
    variables: { 
      HotelID: RegistrationDetails?.Booking?.HotelID 
    },
    fetchPolicy: 'no-cache',
  });

  const [OnlinePayment, { loading: loadingOnlinePayment }] = useOnlinePaymentMutation();

  const PreRegInfo = {
    BookingID: RegistrationDetails?.Booking?.ID,
    HotelID: RegistrationDetails?.Booking?.HotelID,
    FullName: RegistrationDetails?.Guest?.Contact?.FullName,
    RegistrationID: RegistrationDetails?.ID,
    ArrivalDate: RegistrationDetails?.ArrivalDate,
    IsOnlinePayment: GuestAppFeature?.OnlinePayment || JSON.parse(localStorage.getItem('IsOnlinePayment') as any),
    SelfCheckin: GuestAppFeature?.SelfCheckin,
    SelfChooseRoom: GuestAppFeature?.SelfChooseRoom,
    PreCheckinAdvTime: GuestAppFeature?.PreCheckinAdvTime,
    PreRegAdvTime: GuestAppFeature?.PreRegAdvTime
  }

  const DepositInfo = {
    HotelID: RegistrationDetails?.Booking?.HotelID,
    FolioType: FolioType.DepositFolio,
    FolioAmount: Number(BillSummaryDetails?.SecurityDeposit),
    DepositClass: DepositClass.SecurityDeposit,
    PaymentType: PaymentType.Online,
    BookingID: RegistrationDetails?.Booking?.ID,
    RegistrationID: RegistrationDetails?.ID
  }

  const [PreRegPaymentInsert, { loading: loadingPreRegPaymentInsert }] = usePreRegPaymentInsertMutation({
    variables: {
      HotelID: RegistrationDetails?.Booking?.HotelID,
      BookingID: RegistrationDetails?.Booking?.ID,
      RegistrationID: RegistrationDetails?.ID,
      Amount: `${BillSummaryDetails?.TotalAmount}`,
      RoomID: JSON.parse(localStorage.getItem('SelectedRoom') as any)?.ID
        ? JSON.parse(localStorage.getItem('SelectedRoom') as any)?.ID
        : undefined,
      RoomTypeID: JSON.parse(localStorage.getItem('SelectedRoom') as any)?.ID
        ? JSON.parse(localStorage.getItem('SelectedRoom') as any)?.RoomTypeID
        : undefined,
      DepositInput: DepositInfo,
      PaymentMode: "Online"
    },
    onCompleted: data => {
      const advPaymentID = data?.PreRegPaymentInsert?.AdvPaymentID;
      if (advPaymentID ||
        (advPaymentID === undefined && data?.PreRegPaymentInsert?.IsCMS === true)
      ) {
        localStorage.setItem('ReceiptNo', data?.PreRegPaymentInsert?.ReceiptNo);
        if (advPaymentID) {
          localStorage.setItem('AdvPaymentID', advPaymentID);
        } else {
          localStorage.removeItem('AdvPaymentID');
        }
        OnlinePayment({
          variables: {
            redirectUrl: IsXendit ? PaymentUrl : `${PaymentUrl}/pre-checkin/form/room/:status`,
            PayAmount: Number(BillSummaryDetails?.TotalAmount),
            Detail: 'Detail',
            Name: RegistrationDetails?.Guest?.Contact?.FullName,
            MobileNumber: RegistrationDetails?.Guest?.Contact?.MobileNo,
            Email: RegistrationDetails?.Guest?.Contact?.Email,
            HotelID: RegistrationDetails?.Booking?.HotelID,
            ReceiptNo: data.PreRegPaymentInsert?.ReceiptNo,
            ...(advPaymentID ? { AdvancePaymentID: advPaymentID } : {}),
            Title: 'Room Payment',
            IsGuestApp: false
          },
        }).then(i => {
          if (i.data?.OnlinePayment?.code === 'SUCCESS') {
            localStorage.setItem('CheckOutID', i.data.OnlinePayment.item!.checkoutId!);
            localStorage.setItem('RegistrationDetails', JSON.stringify(RegistrationDetails));
            window.location.href = i.data?.OnlinePayment?.item?.url!;
          } else {
            i.data?.OnlinePayment?.error?.code !== ''
              ? snackFunc(i.data?.OnlinePayment?.error?.message!, false)
              : snackFunc('Insert Fail', false);
          }

          localStorage.setItem('PreRegInfo', JSON.stringify(PreRegInfo))
        });
      }
    },
  });

  const NoOfDays = differenceInDays(
    new Date(dateFormat(RegistrationDetails?.DepartureDate, 'yyyy-mm-dd')),
    new Date(dateFormat(RegistrationDetails?.ArrivalDate, 'yyyy-mm-dd'))
  );

  return BillSummaryDetailsLoadings || loadingPreRegPaymentInsert || loadingOnlinePayment || GuestAppFeatureLoadings || loadingInfo ? (
    <Loading />
  ) : (
    <>
      <Box>
        <Card
          sx={{
            borderRadius: '5px',
            boxShadow:
              '0 3px 1px -2px transparent, 2px 4px 4px -2px rgb(0 0 0 / 15%), -2px -1px 4px -2px rgb(0 0 0 / 15%)',
          }}
        >
          <CardContent sx={{ ':last-child': { p: '10px' } }}>
            <Box width="100%" display="flex" style={{ borderBottom: '1px solid #ccc', marginBottom: '5px' }}>
              <Typography fontSize="14px" fontWeight={600} mb="5px">
                Bill Summary
              </Typography>
            </Box>
            {(PreRegBookingInfo?.IsCms === true) ? (
              null
            ) : (
              <>
                <Box width="100%" display="flex">
                  <Box width="50%" display="flex">
                    <Typography fontSize="12px" fontWeight={600} align="left">
                      Room Charge - {NoOfDays} Night
                    </Typography>
                  </Box>
                  <Box width="50%" display="flex" sx={{ flexDirection: 'row-reverse' }}>
                    <Typography fontSize="12px" fontWeight={600}>
                      {amtStr(BillSummaryDetails?.BaseAmount)}
                    </Typography>
                  </Box>
                </Box>
                <Box width="100%" display="flex">
                  <Typography fontSize="10px" mb="5px">
                    {dateFormat(RegistrationDetails?.ArrivalDate, 'dd/mm/yyyy')} -{' '}
                    {dateFormat(RegistrationDetails?.DepartureDate, 'dd/mm/yyyy')}
                  </Typography>
                </Box>
                <Box width="100%" display="flex">
                  <Box width="50%" display="flex">
                    <Typography fontSize="12px" fontWeight={600} align="left">
                      Preferred Room
                    </Typography>
                  </Box>
                  <Box width="50%" display="flex" sx={{ flexDirection: 'row-reverse' }}>
                    <Typography fontSize="12px" fontWeight={600}>
                      {amtStr(BillSummaryDetails?.PreferredRoomCharge)}
                    </Typography>
                  </Box>
                </Box>
                <Box width="100%" display="flex">
                  <Typography fontSize="10px" mb="5px">
                    {dateFormat(RegistrationDetails?.ArrivalDate, 'dd/mm/yyyy')}
                  </Typography>
                </Box>
                {Array.isArray(BillSummaryDetails?.TaxBreakdown) &&
                BillSummaryDetails?.TaxBreakdown?.length > 0 ? (
                  BillSummaryDetails?.TaxBreakdown?.map((tax: any, i: number) => (
                    <Box key={i} width="100%" display="flex">
                      <Box width="50%" display="flex" style={{ marginBottom: '5px' }}>
                        <Typography fontSize="12px" fontWeight={600} align="left">
                          {tax?.Name === 'ServiceCharge' ? 'Service Charge' : tax?.Name}
                        </Typography>
                      </Box>
                      <Box width="50%" display="flex" sx={{ flexDirection: 'row-reverse' }}>
                        <Typography fontSize="12px" fontWeight={600}>
                          {amtStr(tax?.Amount)}
                        </Typography>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Box width="100%" display="flex">
                    <Box width="50%" display="flex" style={{ marginBottom: '5px' }}>
                      <Typography fontSize="12px" fontWeight={600} align="left">
                        Service Tax
                      </Typography>
                    </Box>
                    <Box width="50%" display="flex" sx={{ flexDirection: 'row-reverse' }}>
                      <Typography fontSize="12px" fontWeight={600}>
                        {amtStr(Number(BillSummaryDetails?.TaxAmount) + Number(BillSummaryDetails?.ServiceCharge))}
                      </Typography>
                    </Box>
                  </Box>
                )}
              </>
            )}
            {BillSummaryDetails?.IsPreCheckInPrompt && (
              <Box width="100%" display="flex" style={{ borderBottom: '1px solid #ccc', marginBottom: '5px' }}>
                <Box width="50%" display="flex" style={{ marginBottom: '5px' }}>
                  <Typography fontSize="12px" fontWeight={600} align="left">
                    Security Deposit
                  </Typography>
                </Box>
                <Box width="50%" display="flex" sx={{ flexDirection: 'row-reverse' }}>
                  <Typography fontSize="12px" fontWeight={600}>
                    {amtStr(Number(BillSummaryDetails?.SecurityDeposit))}
                  </Typography>
                </Box>
              </Box>
            )}
            <Box width="100%" display="flex" style={{ borderBottom: '1px solid #ccc', marginBottom: '5px' }}>
              <Box width="50%" display="flex" style={{ marginBottom: '5px' }}>
                <Typography fontSize="12px" fontWeight={600} align="left">
                  Total
                </Typography>
              </Box>
              <Box width="50%" display="flex" sx={{ flexDirection: 'row-reverse' }}>
                <Typography fontSize="12px" fontWeight={600}>
                  {amtStr(BillSummaryDetails?.TotalAmount)}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
      <Footer
        primary={true}
        options={[
          {
            name: 'Payment',
            onClick: () => PreRegPaymentInsert(),
          },
        ]}
      />
      <SnackBarMsg open={openSnackBar} message={snackBarMessage} />
    </>
  );
};
